import { apiRequest, apiFormRequest } from './api';

// Education
export const getEducation = async () => {
    const response = await apiRequest('/education');
    return response.data;
};

export const createEducation = async (data) => {
    const response = await apiRequest('/education', {
        method: 'POST',
        body: JSON.stringify(data)
    });
    return response.data;
};

export const updateEducation = async ({ id, ...data }) => {
    const response = await apiRequest(`/education/${id}`, {
        method: 'PUT',
        body: JSON.stringify(data)
    });
    return response.data;
};

export const deleteEducation = async (id) => {
    await apiRequest(`/education/${id}`, {
        method: 'DELETE'
    });
};

// Experience
export const getExperience = async () => {
    const response = await apiRequest('/experience');
    return response.data;
};

export const createExperience = async (data) => {
    const response = await apiRequest('/experience', {
        method: 'POST',
        body: JSON.stringify(data)
    });
    return response.data;
};

export const updateExperience = async ({ id, ...data }) => {
    const response = await apiRequest(`/experience/${id}`, {
        method: 'PUT',
        body: JSON.stringify(data)
    });
    return response.data;
};

export const deleteExperience = async (id) => {
    await apiRequest(`/experience/${id}`, {
        method: 'DELETE'
    });
};

// Skills
export const getSkills = async () => {
    const response = await apiRequest('/skills');
    return response.data;
};

export const createSkill = async (data) => {
    const response = await apiRequest('/skills', {
        method: 'POST',
        body: JSON.stringify(data)
    });
    return response.data;
};

export const updateSkill = async ({ id, ...data }) => {
    const response = await apiRequest(`/skills/${id}`, {
        method: 'PUT',
        body: JSON.stringify(data)
    });
    return response.data;
};

export const deleteSkill = async (id) => {
    await apiRequest(`/skills/${id}`, {
        method: 'DELETE'
    });
};

export const deleteSkillsBulk = async (ids) => {
    await apiRequest('/skills/bulk-delete', {
        method: 'POST',
        body: JSON.stringify({ ids })
    });
};

// Projects
export const getProjects = async () => {
    const response = await apiRequest('/projects');
    return response.data;
};

export const createProject = async (data) => {
    if (data instanceof FormData) {
        const response = await apiFormRequest('/projects', data);
        return response.data;
    }
    const response = await apiRequest('/projects', {
        method: 'POST',
        body: JSON.stringify(data)
    });
    return response.data;
};

export const updateProject = async ({ id, ...data }) => {
    // Check if data contains formData property (passed from hook) or if data itself is FormData
    // In ProjectsModal.jsx, I passed { id: itemToEdit.id, formData } which results in { formData: ... } object here
    // wait, argument destructuring {id, ...data} means data will be { formData: ... }
    
    let bodyData = data;
    let isFormData = false;

    if (data.formData instanceof FormData) {
        bodyData = data.formData;
        isFormData = true;
    } else if (data instanceof FormData) {
        // unlikely with current signature {id, ...data} unless {id} was part of formData? No.
    }

    if (isFormData) {
        const response = await apiFormRequest(`/projects/${id}`, bodyData, {
            method: 'PUT' // apiFormRequest defaults to POST
        });
        return response.data;
    }

    const response = await apiRequest(`/projects/${id}`, {
        method: 'PUT',
        body: JSON.stringify(data)
    });
    return response.data;
};

export const deleteProject = async (id) => {
    await apiRequest(`/projects/${id}`, {
        method: 'DELETE'
    });
};
